import { PersonalizationEngineConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

const personalizationEngineConfigs: PersonalizationEngineConfigs = {};
export default personalizationEngineConfigs;
